import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminComplaints = lazy(() => import("@/pages/admin/AdminComplaints"));

export const Route = createFileRoute("/admin/complaints")({
  component: AdminComplaints,
});
